// https://gist.github.com/thevangelist/8ff91bac947018c9f3bfaad6487fa149
const convertToKebabCase = string => {
  return string
    .replace(/([a-z])([A-Z])/g, '$1-$2') // get all lowercase letters that are near to uppercase ones
    .replace(/[\s_]+/g, '-') // replace all spaces and low dash
    .toLowerCase();
};
const accents = require('remove-accents');

const formatNumber = number => new Intl.NumberFormat().format(number);

const displayLabelIfPresent = obj => (obj ? obj.label : '');

const displayAcCodelIfPresent = obj => (obj ? obj.acCode : '');

export {
  convertToKebabCase,
  accents,
  formatNumber,
  displayLabelIfPresent,
  displayAcCodelIfPresent,
};
